import axios from 'axios';
import store from '../store/index';
import {
  _logReport
} from './errorHandler';
import { Dialog } from 'vant';
import { clearCookie, weChatLogin } from './login';

const requestList = [];
const CancelToken = axios.CancelToken;
const sources = {};
const service = axios.create({ baseURL: process.env.VUE_APP_API_BASE_URL })
service.interceptors.request.use((config) => {
  const request = JSON.stringify(config.url) + JSON.stringify(config.data);
  config.cancelToken = new CancelToken((cancel) => {
    sources[request] = cancel;
  });
  if (store.state.key) {
    config.headers['Authorization'] = store.state.key;
  }
  if (requestList.includes(request)) {
    sources[request]('取消重复请求');
  } else {
    requestList.push(request);
  }
  // if (config.url.indexOf('/') === 0) {
  //   config.url = process.env.NODE_ENV === 'production' ? '/zh' + config.url : config.url;
  // }
  return config;
}, function (error) {
  return Promise.reject(error);
});
service.interceptors.response.use((response) => {
  const request = JSON.stringify(response.config.url) + JSON.stringify(response.config.data);
  requestList.splice(requestList.findIndex(item => item === request), 1);
  const errMsg = response.data.errMsg || response.data.err_msg || response.data.msg || response.data.Msg;
  const code = response.data.code || response.data.Code;
  switch (code) {
    case 40003: // 登录态失效重新登录
      // Dialog.alert({
      //   message: errMsg || '登录失效请重新登录'
      // }).then(() => {
        clearCookie('needkey8');
        sessionStorage.removeItem('needkey8');
        weChatLogin();
      // });
      return Promise.reject(response.data);
    case 30002: // 该订单已支付, 不需要重复支付
      Dialog.alert({
        message: errMsg
      });
      return Promise.reject(response.data);
    case 40023: // 参数错误
      if (response.config.url.includes('/api/coupon/user_coupon_add') || response.config.url.includes('/pay/order/detail')) {
        console.log(response.data.errMsg);
      } else {
        // Dialog.alert({
        //   message: errMsg || '请求参数有误，请联系技术人员'
        // });
      }
      return Promise.reject(response.data);
    case 50000:
      Dialog.alert({
        message: errMsg || '登录失效请重新登录'
      });
      return Promise.reject(response.data);
    case 400: // go 那边的接口
      Dialog.alert({
        message: errMsg
      });
      return Promise.reject(response.data);
    default:
      return response.data;
  }
}, (error) => {
  _logReport({
    message: 'Error:' + error
  });
  if (axios.isCancel(error)) {
    requestList.length = 0;
    throw new axios.Cancel('cancel request');
  }
  return Promise.reject(error);
});
const request = function () {
  let allArguments = {
    url: '',
    data: {},
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    timeout: 10000
  };
  if (arguments.length === 1) {
    allArguments = arguments[0];
  } else if (arguments.length > 1) {
    const methodList = ['get', 'post', 'put', 'delete'];
    const argumentsArr = Array.prototype.slice.call(arguments);
    argumentsArr.map((item) => {
      if (item.constructor === String) {
        item = item.toLowerCase();
        if (methodList.indexOf(item) !== -1) {
          allArguments.method = item;
        } else if (item.includes('/')) {
          allArguments.url = item;
        }
      } else if (item.constructor === Object) {
        if (item.hasOwnProperty('header')) {
          allArguments.header = item.header;
        } else if (item.hasOwnProperty('timeout')) {
          allArguments.timeout = item.timeout;
        } else {
          allArguments.data = item;
        }
      }
    });
  }
  return new Promise((resolve, reject) => {
    service(allArguments).then(response => {
      resolve(response);
    }, err => {
      if (!err.Cancel) {
        reject(err);
      }
    }).catch(err => {
      reject(err);
    });
  });
};
// function serialiseObject(obj) {
//  const prefix = '?';
//  if (obj && Object.keys(obj).length) {
//    return prefix + Object.keys(obj).map(key =>
//      `${key}=${encodeURIComponent(obj[key])}`,
//    ).join('&');
//  }
//  return '';
// }
export {
  request
};
